<template>
  <v-main>
    <v-container fluid>
      <div class="dj-page-head">
        <div class="dj-page-head__text dj-page-head__row">
          <backbutton></backbutton>
          <h1 class="dj-page-title">Values</h1>
        </div>
        <div class="dj-page-actions">
          <v-btn fab small depressed color="primary" to="/values/create">
            <v-icon dark> mdi-plus </v-icon>
          </v-btn>
        </div>
      </div>
      <v-progress-linear
        v-if="isLoading"
        indeterminate
        color="primary"
      ></v-progress-linear>
      <v-row v-else>
        <v-col md="12">
          <v-card elevation="6">
            <v-simple-table fixed-header>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Sr No</th>
                    <th class="text-left">Name</th>
                    <th class="text-left">Type</th>
                    <th class="text-right">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(value, i) in values" :key="value.name">
                    <td>{{ i + 1 }}</td>
                    <td>{{ value.name }}</td>
                    <td>{{ value.type }}</td>
                    <td class="text-right">
                      <v-tooltip left v-if="value.id">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-bind="attrs"
                            v-on="on"
                            small
                            color="primary"
                            icon
                            @click="delete_data(value.id, 'values')"
                          >
                            <v-icon>mdi-delete-outline</v-icon>
                          </v-btn>
                        </template>
                        <span>Delete Value</span>
                      </v-tooltip>
                      <v-btn
                        class="mx-2"
                        fab
                        x-small
                        color="primary"
                        :to="`/values/${value.id}`"
                      >
                        <v-icon dark> mdi-pencil </v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
import backbutton from "@/components/backbutton.vue";
export default {
  components: { backbutton },
  name: "ValuesPage",
  data() {
    return {
      values: [],
      isLoading: false,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      let values = await axios.get(`values`);
      this.values = values.data.data;
      this.isLoading = false;
    },
    async delete_data(id, table) {
      let check = confirm("Are you sure you want to delete the data");
      if (check) {
        try {
          this.isLoading = true;
          await axios.post(`delete?id=${id}&table_name=${table}`);
          this.isLoading = false;
          this.getData();
        } catch (e) {
          this.isLoading = false;
        }
      }
    },
  },
};
</script>
